import { gql } from '@apollo/client';

export const menuCategoryFields = gql`
  fragment MenuCategoryFields on MenuCategory {
    id
    name
    position
    applyTowardMinimum
    salesCategory {
      id
      name
    }
    taxes {
      id
      enabled
      name
      rate
    }
    fees {
      id
      enabled
      name
      rate
    }
  }
`;

export const menuQuery = gql`
  query VenueMenu($id: ID!) {
    venue(id: $id) {
      id
      taxes {
        id
        enabled
        name
        rate
      }
      fees {
        id
        enabled
        name
        rate
        taxes {
          id
          name
        }
      }
      menu {
        id
        name
        pdf
        menuCategories {
          id
          name
          ...MenuCategoryFields
        }
        salesCategories {
          id
          name
        }
        menuItems {
          id
          name
          details
          internalDetails
          displayOnGuestMenu
          displayOnExpressBook
          price
          unit
          position
          image
          addons {
            id
            name
            price
          }
          choices {
            id
            name
            limit
            options {
              id
              name
              price
            }
          }
          taxes {
            id
            enabled
            name
            rate
          }
          fees {
            id
            enabled
            name
            rate
          }
          menuCategory {
            id
            name
            position
            applyTowardMinimum
          }
          quantitiesOnExtrasEnabled
          quantitiesEditableByGuest
        }
      }
    }
  }
  ${menuCategoryFields}
`;
